import { getValueByPath } from "./getValueByPath";

function getEventsLogMessage(event, templates, fieldMap) {
    const eventKey = getValueByPath(event, "payload.translationKey");
    let template = templates[eventKey];

    if (event.deviceType === "nc" &&
        (eventKey === "sw_port_error_recover" || eventKey === "router_port_error_recover") &&
        getValueByPath(event, "payload.errorType") === null) {
        template = template?.replace(". Error: <ErrorTypeString>", ".");
    }

    const mapRule = fieldMap[eventKey] || {};

    if (!template) return "-";

    const formatValue = (value) => {
        if (value === undefined || value === null) return "";
        if (Array.isArray(value)) return value.join(", ");
        if (typeof value === "object") {
            return Object.entries(value)
                .map(([k, v]) => `${k}: ${formatValue(v)}`)
                .join(", ");
        }
        return String(value);
    }

    return template
        .replace(/<([^<>]+)>/g, (match, key) => {
            const path = mapRule[key];
            const value = getValueByPath(event, path);
            return value !== undefined ? formatValue(value) : match;
        })
        .replace(/{([^{}]+)}/g, (match, key) => {
            const path = mapRule[key];
            const value = getValueByPath(event, path);
            return value !== undefined ? formatValue(value) : match;
        });
}

export default getEventsLogMessage
